import { Redirect, Route, Switch } from 'react-router-dom';
import { rootPaths } from 'routes/paths';
import { GiftCardEditorPage } from 'features/my-gift-cards/pages/GiftCardEditorPage';
import { Title } from 'shared';
import { useTranslation } from 'hooks/useTranslation';
import { subscriptionPaths } from 'features/subscription/routes/paths';
import { PlanView } from 'features/subscription/pages/PlansView';

export const SubscriptionRouter = () => {
  const { t } = useTranslation('app');

  return (
    <>
      <Title title={t('subscription')} />
      <Switch>
        <Route path={subscriptionPaths.static.root} exact component={PlanView} />
        <Route path={subscriptionPaths.static.card} exact component={GiftCardEditorPage} />
        <Route>
          <Redirect to={rootPaths.static.notFound} />
        </Route>
      </Switch>
    </>
  );
};
